module.exports = __webpack_public_path__ + "static/media/InternshipStats.04dfba96.png";